import { connect } from 'react-redux';
import DefaultPricesManagementEditPage from './DefaultPricesManagementEditPage';
import { updateAsync } from './actions';

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: model => dispatch(updateAsync(model)),
  };
};

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => {
  return {
    onSubmit: model =>
      propsFromDispatch.onSubmit({
        ...model,
        id: ownProps.match.params.id,
      }),
    ...ownProps,
  };
};

const DefaultPricesManagementEditPageContainer = connect(
  undefined,
  mapDispatchToProps,
  mergeProps,
)(DefaultPricesManagementEditPage);

export default DefaultPricesManagementEditPageContainer;
